import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import swal from 'sweetalert';
import { useHistory } from 'react-router-dom'
import { Modal } from "react-bootstrap";
import Select from 'react-select';
import moment from 'moment';
import formatNumber from "../common_component/formatNumber.js";

import { setCookie, getCookie } from '../common_component/cookie.js';
import { useTheme } from "./theme-provider.js";
import { useAuthData } from "./auth-provider.js";
import PageError from "../common_component/PageError.js";
import { io } from "socket.io-client";

function CreateDeliveryOrder() {
    const [state, setstate] = useState(2);
    const [navtype, setnavtype] = useState("General");
    const { theme, dropdownStyleDark } = useTheme();
    const history = useHistory()

    const [challanList, setChallanList] = useState([])
    const [invoiceList, setInvoiceList] = useState([]);
    const [deliveryAgentList, setDeliveryAgentList] = useState([])
    const [warehouseList, setWarehouseList] = useState([]);

    const [packageSpecificationModalShow, setPackageSpecificationModalShow] = useState(false);

    const [challanListApiState, setChallanListApiState] = useState(false);
    const [invoiceListApiState, setInvoiceListApiState] = useState(false);
    const [orderListApiState, setOrderListApiState] = useState(false);
    const [shippingProviderListApiState, setShippingProviderListApiState] = useState(false)
    const [deliveryAgentListApiState, setDeliveryAgentListApiState] = useState(false)
    const [vehicleListApiState, setVehicleListApiState] = useState(false)

    const [orderNumber, setOrderNumber] = useState(null)
    const [orderType, setOrderType] = useState(null);
    const [advanceShippingProviders, setAdvanceShippingProviders] = useState([]);
    const [shippingProviderType, setShippingProviderType] = useState("");
    const [orderDate, setOrderDate] = useState(moment.utc().format('YYYY-MM-DD'))

    const [selectedDeliveryChalan, setSelectedDeliveryChalan] = useState([]);
    const [warehouseWiseItemList, setWarehouseWiseItemList] = useState([]);
    const [warehouseIndex, setWarehouseIndex] = useState(0);

    const [shippingProviderList, setShippingProviderList] = useState([]);
    const [shippingProvider, setShippingProvider] = useState(null);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [orderList, setOrderList] = useState([]);
    const [selectedInvoice, setSelectedInvoice] = useState(null);
    const [selectedDeliveryAgent, setSelectedDeliveryAgent] = useState(null)

    const [selectedWarehouse, setSelectedWarehouse] = useState(null)
    const [selectedVehicle, setSelectedVehicle] = useState(null);
    const [vehicleList, setVehicleList] = useState([])
    const [distanceDetails, setDistanceDetails] = useState({ input_km: 0, calculated_km: 0, source_coords: null, destination_coords: null })

    const [courierName, setCourierName] = useState("")
    const [courierTrackingId, setCourierTrackingId] = useState("")

    const [mainSubmitButtonState, setMainSubmitButtonState] = useState(false)

    const [branchList, setBranchlist] = useState([])
    const [transactionSeriesList, setTransactionSeriesList] = useState([])
    const [selectedBranch, setSelectedBranch] = useState(null);
    const [selectedTransactionSeries, setSelectedTransactionSeries] = useState(null);

    const [addDeliveryAgentModalShow, setAddDeliveryAgentModalShow] = useState(false)
    const [deliveryAgentName, setDeliveryAgentName] = useState("")
    const [deliveryAgentPhone, setDeliveryAgentPhone] = useState("")
    const [deliveryAgentEmail, setDeliveryAgentEmail] = useState("")
    const [deliveryAgentCompanyName, setDeliveryAgentCompanyName] = useState("")
    const [deliveryAgentCompanyPhone, setDeliveryAgentCompanyPhone] = useState("")
    const [deliveryAgentCompanyWebsite, setDeliveryAgentCompanyWebsite] = useState("")
    const [deliveryAgentCompanyAddress, setDeliveryAgentCompanyAddress] = useState("")
    const [deliveryAgentSubmitButtonState, setDeliveryAgentSubmitButtonState] = useState(false)

    const apiController = useRef(new AbortController());
    const socketRef = useRef(null);

    const formatNumberOptions = {
        decimalPlaces: 2,
        removeTrailingZeros: true,
        currencyFormat: '1,234,567.89'
    };

    var page_name = "create-delivery-order";

    const { user, read, write, visibility, organization_id } = useAuthData(page_name);

    const loaderstyle = {
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: "auto",
        marginBottom: "auto",
    };

    useEffect(() => {
        socketRef.current = io(`${process.env.REACT_APP_SOCKET_SERVER_URL}`, { transports: ["websocket"] });

        return () => {
            socketRef.current.disconnect();
        };
    }, []);

    useEffect(() => {
        if ((selectedBranch != null) && (transactionSeriesList.length > 0)) {
            let tb = branchList.find(x => x.branch_id == selectedBranch.value)

            setSelectedTransactionSeries({ label: transactionSeriesList.find(x => x.transaction_series_id == tb.default_transaction_series).series_name, value: tb.default_transaction_series })
            setOrderNumber(null)
            getSubSeriesData(tb.default_transaction_series)
        }
    }, [selectedBranch, transactionSeriesList])

    useEffect(() => {
        if (selectedDeliveryChalan !== null && warehouseList.length > 0) {
            let merged = [];
            if (orderType == "Dealer Order") {
                merged = Object.values(
                    selectedDeliveryChalan.reduce((acc, { warehouse_id, item_array }) => {
                        acc[warehouse_id] = acc[warehouse_id] || { warehouse_id, item_array: [] };
                        //acc[warehouse_details] = warehouseList.find(obj => obj.wid == acc[warehouse_id]);
                        item_array.forEach(({ item_id, item_name, quantity }) => {
                            const item = acc[warehouse_id].item_array.find(i => i.item_id === item_id);
                            const inv_item_details = selectedInvoice.item_array.find(i => i.item_id === item_id);
                            item ? item.quantity += quantity : acc[warehouse_id].item_array.push({ item_id, item_name, rate: inv_item_details.rate, discount_type: inv_item_details.discount_type, discount_unit: inv_item_details.discount_unit, taxable: inv_item_details.taxable, tax_group_percentage: inv_item_details.tax_group_percentage, quantity });
                        });
                        return acc;
                    }, {})
                );
            }
            else {
                const warehouseMap = {};

                selectedDeliveryChalan.forEach(({ item_array }) => {
                    item_array.forEach(({ item_id, item_name, warehouse_list }) => {
                        warehouse_list.forEach(({ warehouse_id, quantity }) => {
                            if (!warehouseMap[warehouse_id]) {
                                warehouseMap[warehouse_id] = { warehouse_id, item_array: [] };
                            }
                            const warehouse = warehouseMap[warehouse_id];
                            const item = warehouse.item_array.find(item => item.item_id === item_id);

                            if (item) {
                                item.quantity += quantity;
                            } else {
                                const inv_item_details = selectedInvoice.item_array.find(i => i.item_id === item_id);
                                warehouse.item_array.push({ item_id, item_name, rate: Number(inv_item_details.rate), discount_type: "amount", discount_unit: 0, taxable: false, tax_group_percentage: 0, quantity: quantity });
                            }
                        });
                    });
                });

                merged = Object.values(warehouseMap);
            }
            merged.forEach((obj, i) => {
                obj.order_number = `${orderNumber.prefix_value}-${parseInt(orderNumber.last_count) + (i + 1)}`;
                obj.warehouse_details = warehouseList.find(x => x.wid == obj.warehouse_id);
                obj.package_specifications = { weight: 0, length: 0, breadth: 0, height: 0 }
            });
            setWarehouseWiseItemList(merged);
        }
    }, [selectedDeliveryChalan])

    async function getAdvanceShippingProviders(st) {
        try {
            const response = await fetch(
                `${process.env.REACT_APP_SERVER_URL}/get-advance-shipping-provider-list`, { method: 'POST', body: JSON.stringify({ "email": user.email, "status_type": st, "search_value": null, "page_name": page_name, "flag": "collection_list", "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
            );
            const body = await response.json();
            if (body.operation !== "success") throw "get advance shipping provider list api error"
            const formattedList = ["Porter", "Delhivery", "ShipRocket"].map(provider => {
                const found = body.data.find(sp => sp.shipping_provider_name === provider);
                if (found) {
                    return provider
                }
            });
            setShippingProviderType(formattedList.length > 0 ? formattedList[0] : "Own");
            setAdvanceShippingProviders(formattedList);
        }
        catch (err) {
            if (err.name !== 'AbortError') {
                console.log(err)
            }
        }
    }

    async function getCustomizeShippingProviders() {
        try {
            if (shippingProviderListApiState) {
                apiController.current.abort()
                apiController.current = new AbortController()
            }
            setShippingProviderListApiState(true)
            const response = await fetch(
                `${process.env.REACT_APP_SERVER_URL}/get-all-shipping-providers`, { signal: apiController.current.signal, method: 'POST', body: JSON.stringify({ "email": user.email, "status_type": "All", "search_value": null, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
            );
            const body = await response.json();
            if (body.operation !== "success") throw "get all shipping providers"

            setShippingProviderList(body.data.list)
            setShippingProviderListApiState(false)
        }
        catch (err) {
            if (err.name !== 'AbortError') {
                console.log(err)
            }
        }
    }

    async function getDeliveryAgentBySearch(search_v) {
        try {
            if (deliveryAgentListApiState) {
                apiController.current.abort()
                apiController.current = new AbortController()
            }
            setDeliveryAgentListApiState(true)
            const response = await fetch(
                `${process.env.REACT_APP_SERVER_URL}/get-delivery-partner-by-search`, { signal: apiController.current.signal, method: 'POST', body: JSON.stringify({ "email": user.email, "search_value": search_v, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
            );
            const body = await response.json();
            setDeliveryAgentListApiState(false)
            setDeliveryAgentList(body.data)
        }
        catch (err) {
            if (err.name !== 'AbortError') {
                console.log(err)
            }
        }
    }

    async function getVehicleInformationBySearch(search_v) {
        try {
            if (vehicleListApiState) {
                apiController.current.abort()
                apiController.current = new AbortController()
            }
            setVehicleListApiState(true)
            const response = await fetch(
                `${process.env.REACT_APP_SERVER_URL}/get-vehicle-information-by-search`, { signal: apiController.current.signal, method: 'POST', body: JSON.stringify({ "email": user.email, "search_value": search_v, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
            );
            const body = await response.json();
            // console.log(body)
            setVehicleListApiState(false)
            if (body.operation == "success") {
                setVehicleList(body.data)
            }
        }
        catch (err) {
            if (err.name !== 'AbortError') {
                console.log(err)
            }
        }
    }

    async function getWarehouses() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/list-warehouse`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        if (body.operation == "success") {
            setWarehouseList(body.data)

            const defaultWarehouse = body.data.find(obj => obj.default)
            if (defaultWarehouse) {
                setSelectedWarehouse({ label: defaultWarehouse.name, value: defaultWarehouse.wid })
            } else {
                setSelectedWarehouse({ label: body.data[0].name, value: body.data[0].wid })
            }
        }
    }

    async function getBranchDetails() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-branches`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        // console.log(body)

        if (body.operation == "success") {
            setBranchlist(body.data);
            let t = body.data.find(x => x.default_branch == "yes")
            setSelectedBranch({ label: t.branch_name, value: t.branch_id })
        }
        else {
            throw "branch list api error"
        }
    }

    async function getTransactionSeriesList() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-transaction-series-list`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        // console.log(body)
        if (body.operation == "success") {
            setTransactionSeriesList(body.data)
        }
        else {
            throw "transaction series api list error"
        }
    }

    async function getSubSeriesData(val) {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-series-data-by-name`, { method: 'POST', body: JSON.stringify({ "email": user.email, "sub_series_name": "delivery_order", "transaction_series_id": val, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();

        if (body.operation == "success") {
            setOrderNumber({ prefix_value: body.data.prefix_value, last_count: body.data.last_count })
        }
        else {
            swal({
                title: "Oops",
                text: body.message,
                icon: "warning",
                buttons: {
                    confirm: {
                        text: "Go to transaction series"
                    }
                }
            }).then((val) => {
                if (val) {
                    window.open("/transaction-series")
                }
            })

            console.log("get sub series data api error")
        }
    }

    async function getOrderListBySearch(search_v, flag) {
        try {
            if (orderListApiState) {
                apiController.current.abort()
                apiController.current = new AbortController()
            }
            setOrderListApiState(true);
            const response = await fetch(
                `${process.env.REACT_APP_SERVER_URL}/get-ecommerce-order-by-search`, { signal: apiController.current.signal, method: 'POST', body: JSON.stringify({ "email": user.email, "search_value": search_v, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
            );
            const body = await response.json();
            setOrderListApiState(false);
            const filtered_data = body.data.filter(x => x.challans.length > 0)
            setOrderList(
                filtered_data.map(order => {

                    const formattedInvoices = order.invoices.map(inv => ({
                        ...inv,
                        billing_address: {
                            billing_customer_name: inv.billing_address.first_name,
                            billing_last_name: inv.billing_address.last_name,
                            billing_address: inv.billing_address.address,
                            billing_address_2: "",
                            billing_city: inv.billing_address.city,
                            billing_pincode: inv.billing_address.zip_code,
                            billing_state: inv.billing_address.state,
                            billing_country: inv.billing_address.country,
                            billing_map_coordinates: inv.billing_address.map_coordinates,
                            billing_email: inv.billing_address.email,
                            billing_phone: inv.billing_address.phone_number
                        },
                        shipping_address: {
                            shipping_customer_name: inv.shipping_address.first_name,
                            shipping_last_name: inv.shipping_address.last_name,
                            shipping_address: inv.shipping_address.address,
                            shipping_address_2: "",
                            shipping_city: inv.shipping_address.city,
                            shipping_pincode: inv.shipping_address.zip_code,
                            shipping_state: inv.shipping_address.state,
                            shipping_country: inv.shipping_address.country,
                            shipping_map_coordinates: inv.shipping_address.map_coordinates,
                            shipping_email: inv.shipping_address.email,
                            shipping_phone: inv.shipping_address.phone_number
                        }
                    }));

                    return {
                        label: order.order_number,
                        value: order.order_id,
                        invoices: formattedInvoices,
                        challans: order.challans
                    };
                })
            );

        }
        catch (err) {
            if (err.name !== 'AbortError') {
                console.log(err)
            }
        }
    }

    async function getInvoiceListBySearch(search_v, flag) {
        try {
            if (invoiceListApiState) {
                apiController.current.abort()
                apiController.current = new AbortController()
            }
            let api = "get-delivery-invoice-list-filtered-delivery-ordered-challans";
            if (flag == "Customer Order") {
                api = "get-customer-invoice-by-search";
            }
            else if (flag == "Ecommerce Order") {
                api = "get-ecommerce-invoice-by-search";
            }
            setInvoiceListApiState(true);
            const response = await fetch(
                `${process.env.REACT_APP_SERVER_URL}/${api}`, { signal: apiController.current.signal, method: 'POST', body: JSON.stringify({ "email": user.email, "search_value": search_v, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
            );
            const body = await response.json();
            setInvoiceListApiState(false);
            const filtered_data = body.data.filter(x => x.challans.length > 0)
            setInvoiceList(filtered_data.map(x => {
                if (flag == "Customer Order") {
                    const billing_address = {
                        "billing_first_name": x.dealer_name,
                        "billing_last_name": "",
                        "billing_address": x.billing_address.address_line1,
                        "billing_address_2": x.billing_address.address_line2,
                        "billing_city": x.billing_address.city,
                        "billing_pincode": x.billing_address.pincode,
                        "billing_state": x.billing_address.state,
                        "billing_country": x.billing_address.country,
                        "billing_email": x.customer_email,
                        "billing_phone": x.billing_address.phone,
                        "billing_map_coordinates": x.billing_address.map_coordinates
                    };
                    const shipping_address = {
                        "shipping_first_name": x.dealer_name,
                        "shipping_last_name": "",
                        "shipping_address": x.shipping_address.address_line1,
                        "shipping_address_2": x.shipping_address.address_line2,
                        "shipping_city": x.shipping_address.city,
                        "shipping_pincode": x.shipping_address.pincode,
                        "shipping_country": x.shipping_address.country,
                        "shipping_state": x.shipping_address.state,
                        "shipping_email": x.customer_email,
                        "shipping_phone": x.shipping_address.phone,
                        "shipping_map_coordinates": x.billing_address.map_coordinates
                    };
                    return { label: x.invoice_number, value: x.invoice_id, invoice_currency: x.invoice_currency, item_array: x.item_array, billing_address: billing_address, shipping_address: shipping_address, challans: x.challans }
                }
                else {
                    const billing_address = {
                        "billing_customer_name": x.billing_address.first_name,
                        "billing_last_name": x.billing_address.last_name,
                        "billing_address": x.billing_address.address,
                        "billing_address_2": "",
                        "billing_city": x.billing_address.city,
                        "billing_pincode": x.billing_address.zip_code,
                        "billing_state": x.billing_address.state,
                        "billing_country": x.billing_address.country,
                        "billing_map_coordinates": x.billing_address.map_coordinates,
                        "billing_email": x.billing_address.email,
                        "billing_phone": x.billing_address.phone_number
                    };
                    const shipping_address = {
                        "shipping_customer_name": x.shipping_address.first_name,
                        "shipping_last_name": x.shipping_address.last_name,
                        "shipping_address": x.shipping_address.address,
                        "shipping_address_2": "",
                        "shipping_city": x.shipping_address.city,
                        "shipping_pincode": x.shipping_address.zip_code,
                        "shipping_country": x.shipping_address.country,
                        "shipping_map_coordinates": x.shipping_address.map_coordinates,
                        "shipping_state": x.shipping_address.state,
                        "shipping_email": x.shipping_address.email,
                        "shipping_phone": x.shipping_address.phone_number
                    };

                    return { label: x.invoice_number, value: x.invoice_id, invoice_currency: x.invoice_currency, item_array: x.item_list, billing_address: billing_address, shipping_address: shipping_address, challans: x.challans }
                }
            }))
        }
        catch (err) {
            if (err.name !== 'AbortError') {
                console.log(err)
            }
        }
    }

    useEffect(() => {
        if ((read || write) && (user.email && visibility)) {

            let p1 = getAdvanceShippingProviders()
            let p2 = getBranchDetails()
            let p3 = getTransactionSeriesList()
            let p4 = getWarehouses()
            //let p5 = getVehicleInformationBySearch()
            //let p6 = getDeliveryAgentBySearch();

            Promise.all([p1, p2, p3, p4])
                .then(() => {
                    setstate(1)
                    console.log("all apis done")
                })
                .catch((err) => {
                    setstate(3)
                    console.log(err)
                })
        }

    }, [user, visibility, read, write])

    const newDeliveryAgentSubmit = () => {

        if (deliveryAgentName == "") {
            swal("Oops!", "Delivery Agent Name cannot be empty", "error");
            return
        }
        if (deliveryAgentPhone == "") {
            swal("Oops!", "Delivery Agent Phone cannot be empty", "error");
            return
        }
        let reg1 = /^\+?[0-9]\d{1,20}$/
        if (!reg1.test(deliveryAgentPhone)) {
            swal("Oops!", "Enter Valid Phone", "error");
            return
        }

        let reg2 = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-]+)(\.[a-zA-Z]{2,5}){1,2}$/
        if ((deliveryAgentEmail != "") && (!reg2.test(deliveryAgentEmail))) {
            swal("Oops!", "Enter a valid email", "error");
            return
        }

        var object = {};

        object.agent_name = deliveryAgentName
        object.agent_phone = deliveryAgentPhone
        object.agent_email = deliveryAgentEmail
        object.company_name = deliveryAgentCompanyName
        object.company_phone = deliveryAgentCompanyPhone
        object.company_website = deliveryAgentCompanyWebsite
        object.company_address = deliveryAgentCompanyAddress

        object.organization_id = organization_id;
        object.page_name = page_name;

        setDeliveryAgentSubmitButtonState(true)

        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }
        axios.post(`${process.env.REACT_APP_SERVER_URL}/add-delivery-agent`, object, headers).then((res) => {
            setDeliveryAgentSubmitButtonState(false)
            if (res.data.operation === "success") {
                swal("Great!", "Delivery Agent added successfully!", "success")

                handleAddDeliveryAgentModalClose()
            }
            else {
                swal("Oops!", res.data.message, "error");
            }
        })
            .catch(function (error) {
                console.log(error)
            });
    }

    const handleAddDeliveryAgentModalClose = () => {
        setAddDeliveryAgentModalShow(false)

        setDeliveryAgentName("")
        setDeliveryAgentPhone("")
        setDeliveryAgentEmail("")
        setDeliveryAgentCompanyName("")
        setDeliveryAgentCompanyPhone("")
        setDeliveryAgentCompanyWebsite("")
        setDeliveryAgentCompanyAddress("")
    }

    const validateOrderDetails = () => {
        if (!orderType) {
            swal("Oops!", "Order Type cannot be empty", "error");
            return false;
        }

        if (!selectedInvoice) {
            swal("Oops!", "Invoice cannot be empty", "error");
            return false;
        }

        if (!orderDate) {
            swal("Oops!", "Order Date cannot be empty", "error");
            return false;
        }

        if (!selectedBranch) {
            swal("Oops!", "Branch cannot be empty", "warning");
            return false;
        }

        if (!selectedTransactionSeries) {
            swal("Oops!", "Transaction Series cannot be empty", "warning");
            return false;
        }

        if (selectedDeliveryChalan.length == 0) {
            swal("Oops!", "Please select at least one chalan.", "warning");
            return false;
        }

        if (shippingProviderType === "Own") {
            // if (!shippingProvider) {
            //     swal("Oops!", "Select a Shipping Provider", "error");
            //     return false;
            // }

            if (!selectedDeliveryAgent) {
                swal("Oops!", "Select a Delivery Agent", "error");
                return false;
            }

            if (!selectedWarehouse) {
                swal("Oops!", "Select a Warehouse", "error");
                return false;
            }

            // if (distanceDetails.input_km <= 0) {
            //     swal("Oops!", "Enter a valid distance in km", "error");
            //     return false;
            // }

            // if (!selectedVehicle) {
            //     swal("Oops!", "Vehicle No. cannot be empty", "error");
            //     return false;
            // }

            // if (!courierName) {
            //     swal("Oops!", "Courier Name cannot be empty", "error");
            //     return false;
            // }

            // if (!courierTrackingId) {
            //     swal("Oops!", "Courier Tracking Id cannot be empty", "error");
            //     return false;
            // }
        }

        return true;
    };


    const createOrderDelivery = (val) => {
        if (shippingProviderType !== "Own" && warehouseWiseItemList.length > 0) {
            let t = false;
            for (let i = 0; i < warehouseWiseItemList.length; i++) {
                if (warehouseWiseItemList[i].package_specifications.weight == 0) {
                    swal("Oops!", `The weight of the package specified in ${warehouseWiseItemList[i].order_number} cannot be zero.`, "warning");
                    t = true;
                    break;
                }
                if (warehouseWiseItemList[i].package_specifications.length == 0) {
                    swal("Oops!", `The length of the package specified in ${warehouseWiseItemList[i].order_number} cannot be zero.`, "warning");
                    t = true;
                    break;
                }
                if (warehouseWiseItemList[i].package_specifications.breadth == 0) {
                    swal("Oops!", `The breadth of the package specified in ${warehouseWiseItemList[i].order_number} cannot be zero.`, "warning");
                    t = true;
                    break;
                }
                if (warehouseWiseItemList[i].package_specifications.height == 0) {
                    swal("Oops!", `The height of the package specified in ${warehouseWiseItemList[i].order_number} cannot be zero.`, "warning");
                    t = true;
                    break;
                }
            }
            if (t) {
                setPackageSpecificationModalShow(true);
                return false;
            }
        }

        var object = {};

        object.order_date = orderDate;
        object.delivery_challan_array = selectedDeliveryChalan.map(x => { return { challan_id: x.value, challan_number: x.label } });

        object.order_type = orderType;
        object.selected_invoice = selectedInvoice;
        if (orderType == "Ecommerce Order") {
            object.selected_order = selectedOrder;
        }
        object.warehouse_wise_item_list = warehouseWiseItemList;
        object.shipping_provider_type = shippingProviderType;
        object.branch_id = selectedBranch.value;
        object.transaction_series_id = selectedTransactionSeries.value;

        if (shippingProviderType == "Own") {
            object.delivery_partner = { id: selectedDeliveryAgent.uid, name: selectedDeliveryAgent.name, email: selectedDeliveryAgent.email, phone: selectedDeliveryAgent.phone }
            //object.shipping_provider = { shipping_provider_id: shippingProvider.value, shipping_provider_name: shippingProvider.label }
            // object.delivery_agent = { agent_id: selectedDeliveryAgent.agent_uid, agent_name: selectedDeliveryAgent.agent_name, agent_phone: selectedDeliveryAgent.agent_phone }

            //object.selected_warehouse = selectedWarehouse.value
            //object.distance_details = distanceDetails

            //const vehicle_info = vehicleList.find(x => x.vehicle_information_id == selectedVehicle.value);
            ///object.vehicle_details = { vehicle_information_id: vehicle_info.vehicle_information_id, vehicle_id: vehicle_info.vehicle_id, vehicle_type: vehicle_info.vehicle_type, vehicle_number: vehicle_info.vehicle_number };
            // object.courier_name = courierName
            // object.courier_tracking_id = courierTrackingId
        }

        object.save_flag = val

        object.organization_id = organization_id;
        object.page_name = page_name;

        setMainSubmitButtonState(true)

        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }
        axios.post(`${process.env.REACT_APP_SERVER_URL}/add-delivery-order`, object, headers).then((res) => {

            setMainSubmitButtonState(false)
            if (res.data.operation === "success") {
                if (res.data.final_flag) {
                    socketRef.current.emit("assign_order_to_partner", {
                        partner_id: selectedDeliveryAgent.uid,
                        order_number: res.data.order_number,
                        order_id: res.data.order_id
                    });
                }
                swal("Great!", `Delivery order created successfully!`, "success").then(() => { history.push(`/delivery-order-list`) });
            }
            else {
                swal("Oops!", res.data.message, "error");
            }
        })
            .catch(function (error) {
                console.log(error)
            });
    }

    function getElementByXpath(path) {
        return document.evaluate(path, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;
    }

    function scrollToTop() {
        getElementByXpath("/html/body/div/div/div[2]/div[2]").scrollTo({ top: 0, behavior: 'smooth' });
    }

    const DeliveryOrdersTemplate = ({ orderList }) => {
        return (
            <>
                {
                    orderList.map((warehouse, index) => {
                        return (

                            <div className="card card-flush py-6 flex-row-fluid border border-success mb-5">
                                <div className="card-header">
                                    <div className="card-title">
                                        <h2>#{warehouse.order_number}</h2>
                                    </div>
                                    <div className="card-toolbar">
                                        <button className={`btn btn-sm ${(warehouseWiseItemList.length > 0 && warehouseWiseItemList[index].package_specifications.weight > 0 && warehouseWiseItemList[index].package_specifications.length > 0 && warehouseWiseItemList[index].package_specifications.breadth > 0 && warehouseWiseItemList[index].package_specifications.height > 0) ? "btn-success" : "btn-primary"}`} onClick={() => { setWarehouseIndex(index); setPackageSpecificationModalShow(true); }}>Package Specification</button>
                                    </div>
                                </div>
                                <div className="d-flex flex-column flex-xl-row gap-7 gap-lg-10">
                                    <div className="card card-flush py-4 flex-row-fluid overflow-hidden">
                                        <div className="position-absolute top-0 end-0 opacity-10 pe-none text-end">
                                            <img src="/assets/media/icons/duotune/ecommerce/ecm001.svg" className="w-175px" alt="Location Icon" />
                                        </div>
                                        <div className="card-header">
                                            <div className="card-title">
                                                <h2>PickUp Address</h2>
                                            </div>
                                        </div>
                                        <div className="card-body pt-0">
                                            <div className="address-info">
                                                <div className="location">
                                                    <i className="fas fa-map-marker-alt"></i> {warehouse.warehouse_details.street1}, {warehouse.warehouse_details.city}, {warehouse.warehouse_details.state}
                                                </div>
                                                <div className="pincode">
                                                    <i className="fas fa-thumbtack"></i> {warehouse.warehouse_details.postalcode}
                                                </div>
                                                <div className="country">
                                                    <i className="fas fa-globe"></i> {warehouse.warehouse_details?.country || "India"}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card card-flush py-4 flex-row-fluid overflow-hidden">
                                        <div className="position-absolute top-0 end-0 opacity-10 pe-none text-end">
                                            <img src="/assets/media/icons/duotune/ecommerce/ecm001.svg" className="w-175px" alt="Location Icon" />
                                        </div>
                                        <div className="card-header">
                                            <div className="card-title">
                                                <h2>Billing Address</h2>
                                            </div>
                                        </div>
                                        <div className="card-body pt-0">
                                            <div className="address-info">
                                                <div className="location">
                                                    <i className="fas fa-map-marker-alt"></i> {selectedInvoice.billing_address.billing_address}, {selectedInvoice.billing_address.billing_city}, {selectedInvoice.billing_address.billing_state}
                                                </div>
                                                <div className="pincode">
                                                    <i className="fas fa-thumbtack"></i> {selectedInvoice.billing_address.billing_pincode}
                                                </div>
                                                <div className="country">
                                                    <i className="fas fa-globe"></i> {selectedInvoice.billing_address?.billing_country || "India"}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body pt-0">
                                    <div className="table-responsive border-bottom mb-9">
                                        <table className="table align-middle table-row-dashed fs-6 gy-5 mb-0">
                                            <thead>
                                                <tr className="border-bottom fs-6 fw-bold text-muted">
                                                    <th className="min-w-100px">Products</th>
                                                    <th className="min-w-70px">Quantity</th>
                                                    <th className="min-w-70px">Rate</th>
                                                    <th className="min-w-100px text-end pb-2">Line Total</th>
                                                </tr>
                                            </thead>
                                            <tbody className="fw-semibold text-gray-600">
                                                {
                                                    warehouse.item_array.map((obj, index1) => {
                                                        return (
                                                            <tr key={index1}>
                                                                <td className="fw-bold">{obj.item_name}</td>
                                                                <td>{obj.quantity}</td>
                                                                <td>{selectedInvoice.invoice_currency.currency_symbol}{formatNumber(obj.rate, { ...formatNumberOptions, decimalPlaces: selectedInvoice.invoice_currency.decimal_place })}</td>
                                                                <td className="text-end">{selectedInvoice.invoice_currency.currency_symbol}{formatNumber((((obj.quantity * obj.rate) - (obj.discount_type === "amount" ? obj.discount_unit : obj.quantity * obj.rate * obj.discount_unit / 100)) + (obj.taxable === 0 ? 0 : ((obj.quantity * obj.rate) - (obj.discount_type === "amount" ? obj.discount_unit : obj.quantity * obj.rate * obj.discount_unit / 100)) * (obj.tax_group_percentage / 100))), { ...formatNumberOptions, decimalPlaces: selectedInvoice.invoice_currency.decimal_place })}</td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="mw-300px ms-auto">
                                        <div className="d-flex flex-stack mb-3">
                                            <div className="fw-semibold pe-10 text-gray-600 fs-7">Subtotal:</div>
                                            <div className="text-end fw-bold fs-6 text-gray-800">{selectedInvoice.invoice_currency.currency_symbol} {formatNumber(warehouse.item_array.reduce((p, o) => { return (p + (((o.quantity * o.rate) - (o.discount_type === "amount" ? o.discount_unit : o.quantity * o.rate * o.discount_unit / 100)) + (o.taxable === 0 ? 0 : ((o.quantity * o.rate) - (o.discount_type === "amount" ? o.discount_unit : o.quantity * o.rate * o.discount_unit / 100)) * (o.tax_group_percentage / 100)))); }, 0), { ...formatNumberOptions, decimalPlaces: selectedInvoice.invoice_currency.decimal_place })}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }
            </>
        );
    };

    return (
        <>
            <div>
                <div className="d-flex flex-stack">
                    <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">Create Delivery Order</h1>
                </div>
                <div>
                    {
                        state == 1 ?
                            <>
                                <div className="form d-flex flex-column flex-lg-row">
                                    <div className="d-flex flex-column flex-row-fluid gap-7 gap-lg-10">
                                        <ul className="nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-semibold mb-n2">
                                            <li className="nav-item">
                                                <a className={`nav-link text-active-primary pb-4 cursor-pointer ${navtype === "General" && "active"}`} onClick={(e) => { setnavtype("General"); }}>General</a>
                                            </li>
                                            <li className="nav-item">
                                                <a className={`nav-link text-active-primary pb-4 cursor-pointer ${navtype === "Advance" && "active"}`}
                                                    onClick={(e) => {
                                                        if (!validateOrderDetails()) return;
                                                        setnavtype("Advance");
                                                    }}>Final Orders</a>
                                            </li>
                                        </ul>
                                        <div className="tab-content">
                                            {navtype === "General" &&
                                                <div className={`tab-pane fade ${navtype === "General" && "show active"}`} role="tab-panel">
                                                    <div className="d-flex flex-column gap-7 gap-lg-10">
                                                        <div className="card card-flush py-4">
                                                            <div className="card-header">
                                                                <div className="card-title">
                                                                    <h2>Create Delivery Order</h2>
                                                                </div>
                                                            </div>
                                                            <div className='card-body'>
                                                                <div className="row mb-5">
                                                                    <div className="col-md-4 mb-2">
                                                                        <label className="fs-5 fw-bold mb-2 required">Order Type</label>
                                                                        <Select
                                                                            options={["Customer Order", "Ecommerce Order"].map(x => { return { label: x, value: x } })}
                                                                            value={orderType === null ? null : { label: orderType, vale: orderType }}
                                                                            onChange={(val) => { setOrderType(val.value); setSelectedInvoice(null); setSelectedOrder(null); setOrderList([]); setInvoiceList([]); getOrderListBySearch("", val.value) }}
                                                                            styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                                            placeholder="Choose Order Type"
                                                                        />
                                                                    </div>
                                                                    {orderType === "Ecommerce Order" &&
                                                                        <div className="col-md-4 mb-2">
                                                                            <label className="fs-5 fw-bold mb-2 required">Select Order</label>
                                                                            <Select
                                                                                options={orderList}
                                                                                value={selectedOrder}
                                                                                onChange={(val) => {
                                                                                    setSelectedOrder(val);
                                                                                    console.log(val);
                                                                                    setInvoiceListApiState(true);
                                                                                    setInvoiceList(val.invoices.map(x => {
                                                                                        return { ...x, label: x.invoice_number, value: x.invoice_id, item_array: x.item_list }
                                                                                    }));

                                                                                    setInvoiceListApiState(false);
                                                                                    setChallanListApiState(true);
                                                                                    setChallanList(val.challans.map(x => {
                                                                                        return { ...x, delivery_challan_number: x.ecom_delivery_challan_number, delivery_challan_id: x.ecom_delivery_challan_id }
                                                                                    }));

                                                                                    setChallanListApiState(false);
                                                                                }}
                                                                                onInputChange={(val) => { (val.length > 2) && getOrderListBySearch(val, orderType) }}
                                                                                onMenuClose={() => { getOrderListBySearch("", orderType); }}
                                                                                isLoading={invoiceListApiState}
                                                                                styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                                                placeholder="Choose Order"
                                                                            />
                                                                        </div>}
                                                                    <div className="col-md-4 mb-2">
                                                                        <label className="fs-5 fw-bold mb-2 required">Select Invoice</label>
                                                                        <Select
                                                                            options={invoiceList}
                                                                            value={selectedInvoice}
                                                                            onChange={(val) => {
                                                                                console.log(val)
                                                                                setSelectedInvoice(val);

                                                                                if (orderType !== "Ecommerce Order") {
                                                                                    setChallanListApiState(true);
                                                                                    setChallanList(val.challans);
                                                                                    // setChallanList(val.challans.map(x => {
                                                                                    //     return { ...x, delivery_challan_number: x.ecom_delivery_challan_number, delivery_challan_id: x.ecom_delivery_challan_id }
                                                                                    // }));
                                                                                    setChallanListApiState(false);
                                                                                }
                                                                                // else {
                                                                                //     setChallanList(val.challans);
                                                                                // }

                                                                            }}
                                                                            onInputChange={(val) => { (val.length > 2 && orderType !== "Ecommerce Order") && getInvoiceListBySearch(val, orderType) }}
                                                                            onMenuClose={() => { orderType !== "Ecommerce Order" && getInvoiceListBySearch("", orderType); }}
                                                                            isLoading={invoiceListApiState}
                                                                            styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                                            placeholder="Choose Invoice"
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="row mb-5">
                                                                    <div className="col-md-4 px-1 mb-2">
                                                                        <label className="required fs-5 fw-bold mb-2">Branch:</label>
                                                                        <Select
                                                                            styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                                            options={branchList.map((x) => { return { label: x.branch_name, value: x.branch_id } })}
                                                                            onChange={(val) => {
                                                                                setSelectedBranch(val);
                                                                                setSelectedTransactionSeries(null)
                                                                            }}
                                                                            value={selectedBranch}
                                                                            placeholder="Select Branch"
                                                                        />
                                                                    </div>
                                                                    <div className="col-md-4 px-1 mb-2">
                                                                        <label className="required fs-5 fw-bold mb-2">Transaction Series:</label>
                                                                        <Select
                                                                            styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                                            options={selectedBranch != null && transactionSeriesList.filter(x => branchList.find(a => a.branch_id == selectedBranch.value).transaction_series_id.split(",").includes(x.transaction_series_id)).map(x => { return { label: x.series_name, value: x.transaction_series_id } })}
                                                                            onChange={(val) => { setSelectedTransactionSeries(val); setOrderNumber(""); getSubSeriesData(val.value) }}
                                                                            value={selectedTransactionSeries}
                                                                            placeholder="Select Transaction Series"
                                                                        />
                                                                    </div>
                                                                    <div className="col-md-4 mb-2">
                                                                        <label className="fs-5 fw-bold mb-2 required">Order Date</label>
                                                                        <input type="date" className="form-control form-control-solid" max={new Date().toISOString().split('T')[0]} value={orderDate} onChange={(e) => { setOrderDate(e.target.value) }} />
                                                                    </div>
                                                                </div>
                                                                <div className="row mb-5">
                                                                    <div className="col-md-4 px-1 mb-2">
                                                                        <label className="fs-5 fw-bold mb-2 required">Chalan No.</label>
                                                                        <Select
                                                                            isMulti
                                                                            options={challanList.map(x => { return { label: x.delivery_challan_number, value: x.delivery_challan_id, warehouse_id: x.warehouse_id, item_array: x.item_array } })}
                                                                            value={selectedDeliveryChalan}
                                                                            onChange={(val) => {
                                                                                setSelectedDeliveryChalan(val);
                                                                            }}
                                                                            isLoading={challanListApiState}
                                                                            styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                                            placeholder="Select chalan"
                                                                        />
                                                                    </div>
                                                                    <div className="col-md-4 mb-2">
                                                                        <label className="fs-5 fw-bold mb-2 required">Shipping Provider Type</label>
                                                                        <Select
                                                                            options={[...advanceShippingProviders, "Own"].map(x => ({ label: x, value: x }))}
                                                                            value={shippingProviderType === null ? null : { label: shippingProviderType, vale: shippingProviderType }}
                                                                            onChange={(val) => {
                                                                                setShippingProviderType(val.value);
                                                                                if (val.value === "Own") {
                                                                                    //getCustomizeShippingProviders();
                                                                                    getDeliveryAgentBySearch();
                                                                                }
                                                                            }}
                                                                            styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                                            placeholder="Choose Order Type"
                                                                        />
                                                                    </div>
                                                                    {shippingProviderType === "Own" &&
                                                                        <>
                                                                            {/* <div className="col-md-4 mb-2">
                                                                                <label className="fs-5 fw-bold mb-2 required">Shipping Provider</label>
                                                                                <Select
                                                                                    options={shippingProviderList.map(x => { return { label: x.name, value: x.shipping_provider_id } })}
                                                                                    value={shippingProvider}
                                                                                    onChange={(val) => { setShippingProvider(val); }}
                                                                                    isLoading={shippingProviderListApiState}
                                                                                    isClearable
                                                                                    styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                                                    placeholder="Choose Shipping Provider"
                                                                                />
                                                                            </div> */}
                                                                            <div className="col-md-4 mb-2">
                                                                                <label className="fs-5 fw-bold mb-2 required">Delivery Partner</label>
                                                                                <Select
                                                                                    options={deliveryAgentList.map(x => { return { label: x.name, value: x.uid, email: x.email, phone: x.phone } })}
                                                                                    value={selectedDeliveryAgent == null ? null : { label: selectedDeliveryAgent.name, value: selectedDeliveryAgent.uid }}
                                                                                    onChange={(val) => { setSelectedDeliveryAgent({ name: val.label, email: val.email, phone: val.phone, uid: val.value }); }}
                                                                                    onInputChange={(val) => { (val.length > 2) && getDeliveryAgentBySearch(val) }}
                                                                                    onMenuClose={() => { getDeliveryAgentBySearch(); }}
                                                                                    isLoading={deliveryAgentListApiState}
                                                                                    styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                                                    placeholder="Choose Delivery Partner"
                                                                                />
                                                                                {/* <Select
                                                                                    options={deliveryAgentList.map(x => { return { label: x.agent_name, value: x.delivery_agent_uid } })}
                                                                                    value={selectedDeliveryAgent == null ? null : { label: selectedDeliveryAgent.agent_name, value: selectedDeliveryAgent.agent_uid }}
                                                                                    onChange={(val) => { setSelectedDeliveryAgent({ agent_name: val.label, agent_uid: val.value, agent_phone: deliveryAgentList.find(x => x.delivery_agent_uid == val.value).agent_phone }); }}
                                                                                    onInputChange={(val) => { (val.length > 2) && getDeliveryAgentBySearch(val) }}
                                                                                    onMenuClose={() => { getDeliveryAgentBySearch(); }}
                                                                                    isLoading={deliveryAgentListApiState}
                                                                                    styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                                                    placeholder="Choose Delivery Agent"
                                                                                /> */}
                                                                            </div>
                                                                        </>
                                                                    }
                                                                </div>
                                                                {shippingProviderType === "Own" &&
                                                                    <>
                                                                        {/* <div className="row mb-5">
                                                                            <div className="col-md-4 mb-2">
                                                                                <label className="fs-5 fw-bold mb-2 required">Warehouse</label>
                                                                                <Select
                                                                                    options={warehouseList.map(x => { return { label: x.name, value: x.wid } })}
                                                                                    value={selectedWarehouse}
                                                                                    onChange={(val) => { setSelectedWarehouse(val); }}
                                                                                    isClearable
                                                                                    styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                                                    placeholder="Select Warehouse..."
                                                                                />
                                                                            </div>
                                                                            <div className="col-md-4 mb-2">
                                                                                <label className="fs-5 fw-bold mb-2 required">Select Vehicle</label>
                                                                                <Select
                                                                                    options={vehicleList.map(x => { return { label: `${x.vehicle_id} - ${x.vehicle_number} - ${x.vehicle_model}`, value: x.vehicle_information_id } })}
                                                                                    value={selectedVehicle}
                                                                                    onChange={(val) => { setSelectedVehicle(val); }}
                                                                                    styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                                                    onInputChange={(val) => { (val.length > 2) && getVehicleInformationBySearch(val) }}
                                                                                    isLoading={vehicleListApiState}
                                                                                    isClearable
                                                                                //placeholder="Select Warehouse..."
                                                                                />
                                                                            </div>
                                                                            <div className="col-md-4">
                                                                                <label className="fs-5 fw-bold mb-2 required">Distance(km) to Supply Destination</label>
                                                                                <input type="number" min={0} className="form-control form-control-solid" value={distanceDetails.input_km.toString()} onChange={(e) => { setDistanceDetails({ ...distanceDetails, input_km: e.target.value == "" || parseInt(e.target.value) < 0 ? 0 : parseInt(e.target.value) }) }} />
                                                                            </div>
                                                                        </div>
                                                                        <div className="row mb-5">
                                                                            <div className="col-md-6 mb-2">
                                                                                <label className={`fs-5 fw-bold mb-2 required`}>Courier Name</label>
                                                                                <input type="text" className="form-control form-control-solid" value={courierName} onChange={(e) => { setCourierName(e.target.value) }} />
                                                                            </div>
                                                                            <div className="col-md-6">
                                                                                <label className={`fs-5 fw-bold mb-2 required`}>Courier Tracking Id</label>
                                                                                <input type="text" className="form-control form-control-solid" value={courierTrackingId} onChange={(e) => { setCourierTrackingId(e.target.value) }} />
                                                                            </div>
                                                                        </div> */}
                                                                    </>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            {navtype === "Advance" &&
                                                <div className={`tab-pane fade ${navtype === "Advance" && "show active"}`} role="tab-panel">
                                                    <div className="d-flex flex-column gap-7 gap-lg-10">
                                                        <div className="card card-flush py-4">
                                                            <div className="card-header">
                                                                <div className="card-title">
                                                                    <h2>Delivery Orders</h2>
                                                                </div>
                                                            </div>
                                                            <div className="card-body pt-0">
                                                                <DeliveryOrdersTemplate orderList={warehouseWiseItemList} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                        <div className="d-flex justify-content-end gap-3">
                                            {
                                                navtype === "General" ?
                                                    <button type="button"
                                                        onClick={() => {
                                                            if (selectedDeliveryChalan.length == 0) {
                                                                swal("Oops!", "Please select at least one chalan.", "warning");
                                                                return;
                                                            }
                                                            if (selectedDeliveryAgent == null) {
                                                                swal("Oops!", "Please select a delivery partner.", "warning");
                                                                return;
                                                            }
                                                            setnavtype("Advance");
                                                            scrollToTop();
                                                        }} className="btn btn-lg btn-primary">Process<i className="bi bi-caret-right-fill ms-2 fs-4"></i></button>
                                                    :
                                                    <>
                                                        <button type="button" onClick={() => { setnavtype("General"); scrollToTop(); }} className="btn btn-lg btn-primary"><i className="bi bi-caret-left-fill me-2 fs-4"></i>Previous</button>
                                                        <button data-kt-indicator={mainSubmitButtonState ? "on" : "off"} disabled={mainSubmitButtonState} onClick={(e) => { createOrderDelivery(true) }} className="btn btn-primary">
                                                            <span className="indicator-label">Save Changes</span>
                                                            <span className="indicator-progress">Please wait...
                                                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span>
                                                        </button>
                                                    </>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </>
                            :
                            state == 2 ?
                                <div className="card">
                                    <div className="card-body pt-6">
                                        <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                                    </div>
                                </div>
                                :
                                <PageError />
                    }
                </div>
            </div>
            <Modal show={packageSpecificationModalShow} onHide={() => { setPackageSpecificationModalShow() }} size="lg" centered>
                <Modal.Header>
                    <Modal.Title>Package Specifications</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setPackageSpecificationModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    {warehouseWiseItemList.length > 0 &&
                        <>
                            <div className="mb-10 fv-row">
                                <label className="required form-label">Weight</label>
                                <input type="number" name="weight" className="form-control mb-2" placeholder="Order weight" value={warehouseWiseItemList[warehouseIndex].package_specifications.weight.toString()}
                                    onChange={(e) => {
                                        let temp = warehouseWiseItemList.map(x => { return { ...x } });
                                        temp[warehouseIndex].package_specifications.weight = e.target.value === "" ? 0 : parseFloat(e.target.value);
                                        setWarehouseWiseItemList(temp);
                                    }} />
                                <div className="text-muted fs-7">Set a order weight in kilograms (kg).</div>
                            </div>
                            <div className="fv-row">
                                <label className="required form-label">Dimension</label>
                                <div className="d-flex flex-wrap flex-sm-nowrap gap-3">
                                    <input type="number" min="0" name="length" className="form-control mb-2" placeholder="Length (l)" value={warehouseWiseItemList[warehouseIndex].package_specifications.length.toString()} onChange={(e) => {
                                        let temp = warehouseWiseItemList.map(x => { return { ...x } });
                                        temp[warehouseIndex].package_specifications.length = e.target.value === "" ? 0 : parseFloat(e.target.value);
                                        setWarehouseWiseItemList(temp);
                                    }} />
                                    <input type="number" min="0" name="Breadth" className="form-control mb-2" placeholder="Breadth (w)" value={warehouseWiseItemList[warehouseIndex].package_specifications.breadth.toString()}
                                        onChange={(e) => {
                                            let temp = warehouseWiseItemList.map(x => { return { ...x } });
                                            temp[warehouseIndex].package_specifications.breadth = e.target.value === "" ? 0 : parseFloat(e.target.value);
                                            setWarehouseWiseItemList(temp);
                                        }} />
                                    <input type="number" min="0" name="height" className="form-control mb-2" placeholder="Height (h)" value={warehouseWiseItemList[warehouseIndex].package_specifications.height.toString()} onChange={(e) => {
                                        let temp = warehouseWiseItemList.map(x => { return { ...x } });
                                        temp[warehouseIndex].package_specifications.height = e.target.value === "" ? 0 : parseFloat(e.target.value);
                                        setWarehouseWiseItemList(temp);
                                    }} />
                                </div>
                                <div className="text-muted fs-7">Enter the order dimensions in centimeters (cm).</div>
                            </div>
                        </>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <button type="button"
                        onClick={(e) => {
                            let temp = warehouseWiseItemList.map(x => { return { ...x } });
                            temp[warehouseIndex].package_specifications = { weight: 0, length: 0, breadth: 0, height: 0 };
                            setWarehouseWiseItemList(temp);
                        }} className="btn btn-danger">Clear</button>
                    <button type="button" onClick={(e) => { setPackageSpecificationModalShow(false) }} className="btn btn-info">Save</button>
                </Modal.Footer>
            </Modal>

            <Modal show={addDeliveryAgentModalShow} onHide={() => { handleAddDeliveryAgentModalClose() }} size='lg' centered>
                <Modal.Header>
                    <Modal.Title>Add CreateDeliveryOrder</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { handleAddDeliveryAgentModalClose() }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className='container px-1'>

                        <div className="row mb-5">
                            <div className="col-md-6">
                                <label className="required fs-5 fw-bold mb-2">Delivery Agent Name</label>
                                <input type="text" className="form-control form-control-solid" value={deliveryAgentName} onChange={(e) => { setDeliveryAgentName(e.target.value) }} placeholder="Delivery Agent Name" />
                                <span className="form-text text-muted">Please enter Delivery Agent name.</span>
                            </div>
                            <div className="col-md-6">
                                <label className="required fs-5 fw-bold mb-2">Delivery Agent Phone</label>
                                <input className="form-control form-control-solid" value={deliveryAgentPhone} onChange={(e) => { setDeliveryAgentPhone(e.target.value) }} placeholder="Delivery Agent Phone" />
                            </div>
                        </div>

                        <div className="row mb-5">
                            <div className="col-md-6">
                                <label className="fs-5 fw-bold mb-2">Delivery Agent Email</label>
                                <input type="text" className="form-control form-control-solid" value={deliveryAgentEmail} onChange={(e) => { setDeliveryAgentEmail(e.target.value) }} placeholder="Delivery Agent Email" />
                            </div>
                            <div className="col-md-6">
                                <label className="fs-5 fw-bold mb-2">Company Name</label>
                                <input className="form-control form-control-solid" value={deliveryAgentCompanyName} onChange={(e) => { setDeliveryAgentCompanyName(e.target.value) }} placeholder="Company Name" />
                            </div>
                        </div>

                        <div className="row mb-5">
                            <div className="col-md-6">
                                <label className="fs-5 fw-bold mb-2">Company Phone</label>
                                <input type="text" className="form-control form-control-solid" value={deliveryAgentCompanyPhone} onChange={(e) => { setDeliveryAgentCompanyPhone(e.target.value) }} placeholder="Company Phone" />
                            </div>
                            <div className="col-md-6">
                                <label className="fs-5 fw-bold mb-2">Company Website</label>
                                <input className="form-control form-control-solid" value={deliveryAgentCompanyWebsite} onChange={(e) => { setDeliveryAgentCompanyWebsite(e.target.value) }} placeholder="Company Website" />
                            </div>
                        </div>

                        <div className="row mb-5">
                            <div className="col-md-12">
                                <label className="fs-5 fw-bold mb-2">Company Address</label>
                                <input type="text" className="form-control form-control-solid" value={deliveryAgentCompanyAddress} onChange={(e) => { setDeliveryAgentCompanyAddress(e.target.value) }} placeholder="Company Address" />
                            </div>
                        </div>

                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-danger rounded" onClick={() => { handleAddDeliveryAgentModalClose() }}>Close</button>
                    {
                        write == 1 &&
                        <button className="btn btn-success rounded" data-kt-indicator={deliveryAgentSubmitButtonState ? "on" : "off"} disabled={deliveryAgentSubmitButtonState} onClick={() => { newDeliveryAgentSubmit() }}>
                            <span className="indicator-label">+ Add</span>
                            <span className="indicator-progress">Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </span>
                        </button>
                    }
                </Modal.Footer>
            </Modal>
        </>
    );
}


export default CreateDeliveryOrder;